import React, { useEffect, useState } from "react"
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { orderBy } from "@progress/kendo-data-query";
import { getter } from "@progress/kendo-react-common";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { ColorPicker } from "@progress/kendo-react-inputs";
import { useSelector } from "react-redux";
import addIcon from "../../../assets/images/add.png";
import { fileDocumentService } from "../../../services/fileDocumentTemplateService";
import AddEditDocumentTemplateTags from "./add-document-template-tag";
import Loader from "../../../control-components/loader/loader";
import DeleteDialogModal from "../../../control-components/custom-delete-dialog-box/delete-dialog";
import { NotificationManager } from "src/util/notify";
import DropDownKendoRct from "../../../control-components/drop-down/drop-down";

const DATA_ITEM_KEY = "id";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);

const TemplateTagList = () => {
    const regionData = useSelector((state) => state.getRegion);
    const [loading, setLoading] = useState(false);
    const [tagList, setTagList] = useState([]);
    const [page, setPage] = React.useState(0);
    const [pageSize, setPageSize] = React.useState(10);
    const [sort, setSort] = useState([]);
    const [selectedState, setSelectedState] = React.useState({});
    const [isOpenAddtags, setIsOpenAddtags] = useState(false)
    const [isOpenEditTags, setIsOpenEditTags] = useState(false)
    const [isDeleteTag, setIsDeleteTag] = useState(false)
    const [selected, setSelected] = useState()

    const [fields, setFields] = useState({
        regionName: {},
    });

    useEffect(() => {
        let newObj = {
            id: regionData[0]?.id,
            regionName: regionData[0]?.regionName,
        };
        setFields({
            ...fields,
            regionName: newObj,
        });

    }, []);


    useEffect(() => {
        if (fields.regionName?.id) {
            getDocumentTemplateTags(fields.regionName)
        }
    }, [fields?.regionName?.id])

    const getDocumentTemplateTags = async (value) => {
        setLoading(true);
        await fileDocumentService.getDocumentTemplateTagList(fields?.regionName)
            .then((result) => {
                setLoading(false);
                let list = result.resultData;
                setTagList(list);
            })
            .catch((error) => {
                setLoading(false);
                NotificationManager.success(error);
                // renderErrors(error.message);
            });
    };

    const addTags = (() => {
        setIsOpenAddtags(!isOpenAddtags)
    })

    const handleEditTag = (field) => {
        setIsOpenEditTags(!isOpenEditTags)
        setSelected(field)
    }

    const handleDeleteTag = (field) => {
        setIsDeleteTag(!isDeleteTag)
        setSelected(field)
    }


    const deleteTag = async () => {
        setLoading(true)
        await fileDocumentService.deleteDocumentTemplateTag(selected)
            .then(result => {
                setLoading(false)
                NotificationManager.success("Document Template Tag Delete Successfully");
                getDocumentTemplateTags();
                setIsDeleteTag(false)
            }).catch(error => {
                setLoading(false)
                NotificationManager.error(error);

            });
    }

    const pageChange = (event) => {
        let skip = event.page.skip;
        let take = event.page.take;
        setPage(skip);
        setPageSize(take);
    };

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setFields({
            ...fields,
            [name]: value,
        });
    };

    return (
        <div className="d-flex flex-wrap">

            <div className="col-md-12 col-lg-12">
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-2">
                    <h4 className="address-title text-grey">
                        <span className="f-24">Document Template Labels</span>
                    </h4>
                    <div className="d-flex align-items-end">
                        <button
                            type="button" data-toggle="modal" data-target="#editform"
                            onClick={addTags}
                            className="btn blue-primary text-white d-flex align-items-center mr-3 green-btn btn-primary">
                            <img src={addIcon} alt="" className="mr-2 add-img" />
                            Add Label
                        </button>
                        {/* <div className="">
                            <DropDownKendoRct
                                filterable={true}
                                label="Region"
                                onChange={handleChange}
                                data={regionData}
                                value={fields.regionName}
                                textField="regionName"
                                name="regionName"
                                dataItemKey="id"
                                suggest={true}
                            />
                        </div> */}
                    </div>
                </div>

                { loading === true ? <Loader /> : <div className="grid-table  filter-grid">
                    <div className=" mt-3">
                        <div className="inner-section-edit position-relative text-center">
                            <div className="grid-table  filter-grid header-blue">
                                <div className=" mt-3">
                                    {/* {loading && <Loader />} */}
                                    <Grid
                                        data={orderBy(tagList?.slice(page, pageSize + page), sort).map(
                                            (item) => ({
                                                ...item,
                                                [SELECTED_FIELD]: selectedState[idGetter(item)],
                                            })
                                        )}
                                        checkboxElement
                                        style={{
                                            height: tagList.length > 0 ? "100%" : "250px",
                                        }}
                                        dataItemKey={DATA_ITEM_KEY}
                                        selectedField={SELECTED_FIELD}
                                        skip={page}
                                        take={pageSize}
                                        total={tagList.length}
                                        onPageChange={pageChange}
                                        className="pagination-row-cus"
                                        pageable={{
                                            pageSizes: [10, 20, 30],
                                        }}
                                        sort={sort}
                                        sortable={true}
                                        onSortChange={(e) => {
                                            setSort(e.sort);
                                        }}
                                        scrollable="none"
                                    >
                                        {/* <GridColumn filterable={false} field={SELECTED_FIELD} width="100px" /> */}
                                        <GridColumn
                                            className="cursor-default"
                                            field="id"
                                            title="ID"
                                            width="250px"
                                        />
                                        <GridColumn
                                            className="cursor-default"
                                            field="labelName"
                                            title="Label Name"
                                            width="300px"
                                        />
                                        <GridColumn
                                            title="Tag Color"
                                            width="380px"
                                            cells={{
                                                data: (props) => {
                                                    let field = props?.dataItem?.labelColor;
                                                    return (
                                                        <td className='brushArrow'>
                                                            <ColorPicker
                                                                defaultValue={field}
                                                            />
                                                        </td>
                                                    );
                                                }
                                            }}
                                        />
                                        <GridColumn
                                            width="400px"
                                            filterable={false}
                                            cells={{
                                                data: (props) => {
                                                    let field = props?.dataItem;
                                                    return (
                                                        <td>
                                                            <div className="row-3">
                                                                <div
                                                                    className="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base icon-red"
                                                                    onClick={() => handleDeleteTag(field)}
                                                                >
                                                                    <div className="k-chip-content">
                                                                        <Tooltip anchorElement="target" position="top">
                                                                            <i
                                                                                className={"fa fa-trash"}
                                                                                aria-hidden="true"
                                                                                title={"Delete"}
                                                                            ></i>
                                                                        </Tooltip>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base icon-green m-2"
                                                                    onClick={() => handleEditTag(field)}
                                                                >
                                                                    <div className="k-chip-content">
                                                                        <Tooltip anchorElement="target" position="top">
                                                                            <i className="fas fa-edit" title="Edit"></i>
                                                                        </Tooltip>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    );
                                                }
                                            }}
                                        />
                                    </Grid>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
            </div>
            {
                isOpenAddtags &&
                <AddEditDocumentTemplateTags onClose={addTags} getDocumentTemplateTags={getDocumentTemplateTags} />
            }
            {
                isOpenEditTags &&
                <AddEditDocumentTemplateTags onClose={handleEditTag} selectedTag={selected} getDocumentTemplateTags={getDocumentTemplateTags} />
            }
            {
                isDeleteTag &&
                <DeleteDialogModal
                    onClose={handleDeleteTag}
                    title="Tag"
                    message="tag"
                    activeType={false}
                    handleDelete={deleteTag}
                />
            }
            {/* {
                isUpdateTag &&
                <UpdateClinicTags onClose={handleCloseTag} selectedTag={selectedTag} />
            }
            {
                isAddTag &&
                <AddClinicTags onClose={handleCloseTag} />
            }
            {
                isDeleteTag &&
                <DeleteDialogModal
                    onClose={closeDeleteTag}
                    title="Tag"
                    message="tag"
                    activeType={false}
                    handleDelete={deleteTagAPI}
                />
            } */}
        </div>
    );
}

export default TemplateTagList